import createIcon from '../../createIcon';

/**
 * @component @name SpaceBar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggOVYxM0g2VjlINFYxNUgyMFY5SDE4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SpaceBar = createIcon('SpaceBar', [
  ['path', { d: 'M18 9V13H6V9H4V15H20V9H18Z', key: 'ny3uek' }],
]);

export default SpaceBar;
